/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_DescInputs */

const vi_confirm_return_desc = /** @type {(inputs: Confirm_Return_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vật tư bao bì muốn nhập lại kho. Mặc định = số đã trừ ở bước xác nhận đơn. Bỏ tick hoặc đặt số lượng = 0 nếu vật tư đã hỏng / không tái sử dụng.`)
};

/**

* @param {Confirm_Return_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_desc = /** @type {((inputs?: Confirm_Return_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_desc(inputs)
});